import { Check } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useMemo } from "react";
import { setPatientTrainStatus } from "../../../api/area";
import CloseIcon from "../../../assets/SVG/closeIcon";
import CustomTable from "../../customTable/CustomTable";

export default function TableTrainList({
  rowData,
  areaId,
  children,
  handlePatientClick,
  totalSize,
  pageable,
  setPageable,
}) {
  // Column Definitions: Defines & controls grid columns.
  const [colDefs, defaultColDef] = useMemo(
    () => [
      [
        {
          field: "patientInfo.name",
          headerName: "نام و نام خانوادگی",
          width: 225,
        },
        {
          field: "patientInfo.phone",
          headerName: "شماره تلفن",
          width: 150,
        },
        {
          field: "patientInfo.fatherName",
          headerName: "نام پدر",
          width: 150,
        },
        {
          headerName: "بیمه",
          width: 150,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`insurance_${x.id}`}
                sx={{ lineHeight: "unset" }}
                fontFamily="Vazirmatn"
              >
                {x?.data?.patientInfo?.insurance === "TAKMIL"
                  ? "تکمیلی"
                  : x?.data?.patientInfo?.insurance === "MILITARY"
                    ? "نیروهای مسلح"
                    : x?.data?.patientInfo?.insurance === "TAMIN"
                      ? "تامین اجتماعی"
                      : x?.data?.patientInfo?.insurance === "SALAMAT"
                        ? "سلامت"
                        : "ندارد "}{" "}
              </Typography>
            );
          },
        },
        {
          field: "patientInfo.identifier",
          headerName: "کد ملی",
          width: 150,
        },
        {
          field: "patientInfo.job",
          headerName: "شغل",
          width: 150,
        },
        {
          field: "patientInfo.patientNo",
          headerName: "شماره پرونده",
          width: 150,
        },
        // {
        //   field: "patientInfo.birthDate",
        //   headerName: "تاریخ تولد",
        //   width: 150,
        //   cellRenderer: (x) => {
        //     return (
        //       <>
        //       <Typography fontFamily="Vazirmatn" >{x?.data?.patientInfo?.birthDate.split("-",2)[0]}</Typography>
        //       </>
        //     )}
        // },
        {
          headerName: "عملیات",
          width: 200,
          cellRenderer: (x) => {
            return (
              <Button
                key={`operation_${x.id}`}
                sx={{ cursor: "pointer", fontFamily: "Vazirmatn", gap: "5px" }}
                variant="contained"
                color={!x.data?.trained ? "primary" : "error"}
                onClick={() => {
                  if (!x.data?.trained) {
                    setPatientTrainStatus(areaId, x.data?.patientInfo?.id, true)
                      .then(() => {
                        handlePatientClick(false, x.data);
                      })
                      .catch(() => {});
                    // console.log(x.trained)
                  } else {
                    setPatientTrainStatus(
                      areaId,
                      x.data?.patientInfo?.id,
                      false,
                    )
                      .then(() => {
                        handlePatientClick(true, x.data);
                      })
                      .catch(() => {});
                  }
                }}
              >
                {!x.data.trained ? <Check /> : <CloseIcon color="white" />}
                {!x.data.trained ? "ثبت ورود" : "لغو ثبت ورود"}
              </Button>
            );
          },
        },
      ],
      {
        filter: true,
        editable: true,
      },
    ],
    [areaId, handlePatientClick],
  );

  return (
    <>
      {rowData && (
        <>
          <CustomTable
            totalElements={totalSize}
            onPageChange={(pageIndex, pageSize) => {
              setPageable({
                pageIndex: pageIndex,
                pageSize: pageSize,
              });
            }}
            pageSize={pageable.pageSize}
            currentPage={pageable.pageIndex}
            rowData={rowData}
            columns={colDefs}
            defaultColDef={defaultColDef}
            onCellClicked={
              children
                ? (e) => {
                    window.open(
                      `/parvandeh?areaId=${areaId}&patientIdentifier=${
                        e.data.patientInfo?.identifier
                      }&patientIdentifierType=${
                        e.data.patientInfo?.identifierType
                      }&patientId=${e.data.patientInfo?.id}`,
                      "_blank",
                    );
                  }
                : undefined
            }
          />
        </>
      )}
    </>
  );
}
